import {
  AfterViewInit,
  ChangeDetectionStrategy,
  Component,
  ElementRef,
  EventEmitter,
  Input,
  Output,
  ViewChild,
  ViewEncapsulation,
} from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { TranslateService, TranslateModule } from '@ngx-translate/core';
import { DxTextBoxModule, DxSelectBoxModule, DxTextAreaModule } from 'devextreme-angular';
import { DxTemplateModule } from 'devextreme-angular/core';

@Component({
  selector: 'app-error-dialog',
  templateUrl: './error-dialog.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  encapsulation: ViewEncapsulation.None,
  imports: [
    FormsModule,
    ReactiveFormsModule,
    DxTextBoxModule,
    DxSelectBoxModule,
    DxTemplateModule,
    DxTextAreaModule,
    TranslateModule,
  ],
})
export class ErrorDialogComponent implements AfterViewInit {
  @ViewChild('okFocus') okButton!: ElementRef;

  @Input()
  code?: string;

  @Input()
  isWarning = false;

  @Input()
  message = '';

  @Input()
  showCopy = false;

  @Output() closeClick = new EventEmitter<void>();

  constructor(public translateService: TranslateService) {}

  ngAfterViewInit(): void {
    this.okButton.nativeElement.focus();
  }

  onCopyClick(): void {
    navigator.clipboard.writeText(this.message);
  }

  onCloseClick() {
    this.closeClick.emit();
  }
}
